export default __webpack_public_path__ + "static/media/drop_order.05bbd62d.png";